// "use strict";

// var $ = require("jquery");
// var Flickity = require('flickity');
// require('flickity-as-nav-for');

// function productGallery() {

//     let carouselNav = $('.flickity-nav-gallery');

//     if (!carouselNav.length) {
//         return;
//     }

//     let carouselNavCells = carouselNav.find('.carousel-cell');
//     let hasMultipleCells = false;

//     if ($(window).width() < 768) {
//         hasMultipleCells = carouselNav.find('.carousel-cell').length > 5;
//         const navGallery = new Flickity('.flickity-nav-gallery', {
//             asNavFor: '.flickity-product-gallery',
//             cellAlign: 'left',
//             contain: true,
//             fullscreen: true,
//             pageDots: false,
//             prevNextButtons: hasMultipleCells,
//         });
//     } else {
//         hasMultipleCells = carouselNav.find('.carousel-cell').length > 1;
//     }

//     const carousel = new Flickity('.flickity-product-gallery', {
//         cellAlign: 'left',
//         contain: true,
//         pageDots: false,
//         prevNextButtons: hasMultipleCells,
//     });

//     carouselNav.find('.carousel-cell').on('click', function (event) {
//         let index = $(event.currentTarget).index();
//         carousel.select(index);
//     });

//     jQuery("form.variations_form").on("found_variation", function (event, variation) {
//         const slide = $('.flickity-product-gallery [data-image-id=' + variation.image_id + ']');
//         carousel.select(slide.index());
//     });


//     export { productGallery };




"use strict";

var $ = require("jquery");
var Flickity = require('flickity');
require('flickity-as-nav-for');

function productGallery() {

    let carouselNav = $('.flickity-nav-gallery');

    if (!carouselNav.length) {
        return;
    }

    let carouselNavCells = carouselNav.find('.carousel-cell');
    let hasMultipleCells = false;

        hasMultipleCells = carouselNav.find('.carousel-cell').length > 1;

    const carousel = new Flickity('.flickity-product-gallery', {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: hasMultipleCells,
    });

    carouselNav.find('.carousel-cell').on('click', function (event) {
        let index = $(event.currentTarget).index();
        carousel.select(index);
    });

    jQuery("form.variations_form").on("found_variation", function (event, variation) {
        const slide = $('.flickity-product-gallery [data-image-id=' + variation.image_id + ']');
        carousel.select(slide.index());
    });
};

export { productGallery };